export function SpecUpdateListenerPlugin() {
  return {
    statePlugins: {
      spec: {
        wrapActions: {
          updateSpec: oriAction => (...args) => {
            return oriAction(...args);
          }
        }
      }
    }
  };
};

export function EditorMetadataPlugin(system) {
  return {
    rootInjects: {
      getEditorMetadata() {
        const allErrors = system.errSelectors.allErrors();
        return {
          contentString: system.specSelectors.specStr(),
          contentObject: system.specSelectors.specJson().toJS(),
          isValid: allErrors.size === 0,
          errors: allErrors.toJS()
        };
      }
    }
  };
}


// WEBPACK FOOTER //
// ./src/components/swagger-edit/plugins.js